import React, { useState } from 'react'
import { toast, Notification, Checkbox } from 'components/ui'
import { ConfirmDialog } from 'components/shared'
import { useSelector, useDispatch } from 'react-redux'
//import { useLocation } from 'react-router-dom'
import { toggleDeleteConfirmation } from '../store/stateSlice'
import { deleteEmailTemplate, getEmailTemplateList } from '../store/dataSlice'
import { useTranslation } from 'react-i18next';

const EmailTemplateDeleteConfirmation = () => {
	const dispatch = useDispatch()
	const dialogOpen = useSelector((state) => state.emailTemplatesList.state.deleteConfirmation)
	const selectedLanguage = useSelector((state) => state.selectLang.data.selectedLanguage);
	const selectedProduct = useSelector((state) => state.emailTemplatesList.state.selectedProduct)
	const tableData = useSelector((state) => state.emailTemplatesList.data.tableData)
	const [webMultiLang, setWebMultiLang] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	//const location = useLocation()

	const handleCheckboxChange = (e) => {
		setWebMultiLang(e);
	};

	const { t } = useTranslation();
	const onDialogClose = () => {
		dispatch(toggleDeleteConfirmation(false))
		setWebMultiLang(false);
	}

	const onDelete = async () => {
		dispatch(toggleDeleteConfirmation(false));
		try {
			const success = await deleteEmailTemplate({ Id: selectedProduct, webLangId: selectedLanguage, WebMultiLang: webMultiLang })
			if (success) {
				setIsLoading(false);
				const updatedTableData = { ...tableData, webLangId: selectedLanguage };
				dispatch(getEmailTemplateList(updatedTableData))
				dispatch(toggleDeleteConfirmation(false))
				toast.push(
					<Notification title={t('toast.deleteSuccess')} type="success" duration={1000} />
					, {
						placement: 'top-center'
					}
				)
			}
		} catch (error) {
			toast.push(
				<Notification title={t('toast.deleteFailed')} type="danger" duration={2000}>
				</Notification>
				, {
					placement: 'top-center'
				}
			)
		}
	}

	return (
		<ConfirmDialog
			isOpen={dialogOpen}
			onClose={onDialogClose}
			loading={isLoading}
			onRequestClose={onDialogClose}
			type="danger"
			title={t('translation.icondelete')}
			onCancel={onDialogClose}
			onConfirm={onDelete}
			confirmButtonColor="red-600"
		>
			<p>
				{t('delete.notifydelete')}
			</p>
			<Checkbox
				className="mt-2.5"
				value={webMultiLang}
				onChange={(e) => handleCheckboxChange(e)}
			>
				{t('delete.otherLanguages')}
			</Checkbox>
		</ConfirmDialog>
	)
}

export default EmailTemplateDeleteConfirmation
